import type { ActionIconProps, FloatingPosition } from '@any-ui-react/core';
import type { MouseEventHandler, ReactNode } from 'react';
import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';
import type { MaterialIconsProps } from '@/common/components/shared/material-icons';
import { PlainActionMaterialIcon } from './PlainActionMaterialIcon';

interface Props
  extends Pick<ActionIconProps, 'className' | 'disabled' | 'size' | 'variant'>,
    Pick<MaterialIconsProps, 'fill' | 'fontSize'> {
  iconClassName?: string;
  iconName: string;
  children?: ReactNode;
  hoverCardPosition?: FloatingPosition;
  /** The name of the button, for screen readers and tests; passed to the button as it is. */
  'aria-label'?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const ActionMaterialIcon = ({
  'aria-label': ariaLabel,
  children,
  className,
  disabled,
  fill,
  fontSize,
  hoverCardPosition,
  iconClassName,
  iconName,
  size,
  variant,
  onClick,
}: Props) => {
  const actionIcon = (
    <PlainActionMaterialIcon
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      fill={fill}
      fontSize={fontSize}
      iconClassName={iconClassName}
      iconName={iconName}
      size={size}
      variant={variant}
      onClick={onClick}
    />
  );

  return !children ? (
    actionIcon
  ) : (
    <HoverCardWithIcon customTarget={actionIcon} position={hoverCardPosition}>
      {children}
    </HoverCardWithIcon>
  );
};
